// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1csX-","comment":"styles_comment__3X1u3"};